export default __webpack_public_path__ + "static/media/icn_heart_transparent.4f552dd7.svg";